import { render, staticRenderFns } from "./AthleteSelfAssessmentPage.vue?vue&type=template&id=395666d4&scoped=true&"
import script from "./AthleteSelfAssessmentPage.vue?vue&type=script&lang=ts&"
export * from "./AthleteSelfAssessmentPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395666d4",
  null
  
)

export default component.exports